module.exports = __webpack_public_path__ + "img/newbg_t.841f0fcc.jpg";